import { render, staticRenderFns } from "./RallyChallengeChooser.vue?vue&type=template&id=dbf96788&"
import script from "./RallyChallengeChooser.vue?vue&type=script&lang=ts&"
export * from "./RallyChallengeChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports